export class RunPlanTrackLibrariesUpdateDTO {
    labId: string;
    actionType: any;
    listOfLibrariesWithValue : UpdateActionDTO[]=[];
    constraintTypeToBeUpdated: string;
    constraintIdToBeUpdated: string;
    missingReadsToBeUpdated: string;
    sequencerTypeToBeUpdated: string;
    readModeToBeUpdated: string;
    readLengthToBeUpdated: number;
    libraryIds: string[];
    submitConfirmed: boolean;
    dueDateRawData: string;
}

export class UpdateActionDTO {
    libraryId : string;
    expressFlag : string;
    actionUpdateHistory: TrackLibrariesUpdateHistory;
}

export class TrackLibrariesUpdateHistory{
    actioncomment : string;
    actionDate: Date;
    puid : string;
}